module.exports = __webpack_public_path__ + "static/traveller/img/blank.4fc1c24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blank.png
// module id = mUda
// module chunks = 1 2 3